import Template from './Table.hbs';
import Button from 'views/components/wysiwyg/parts/buttons/Button';
import TableOptionsPopup from 'views/components/wysiwyg/parts/buttons/table/TableOptionsPopup.hbs';
import TableMakerModal from 'views/components/wysiwyg/modals/table/TableMaker';
import TableTemplate from 'views/components/wysiwyg/elements/table.hbs';

export default class Table extends Button {

    // TinyMCE command as default or defined in wysiwyg.js
    command = 'insertTable'

    // Initialize function for initializing button specific logic
    initializeButton() {

        _.bindAll(this,
            'openPopupMenu',
            'closePopupmenu',
            'mouseUpDocument',
            'onClickTableOption'
        );
        // Set the icon to the template
        this.icon = Template();

        // Set the tooltip to a translated string
        this.tooltip = window.i18n.gettext('Table');
        this.addBorderTitle = window.i18n.gettext('Add border');
        this.removeBorderTitle = window.i18n.gettext('Remove border');
    }

    mouseUpDocument(e) {

        // if the target of the click isn't the container this.$el...
        // ... nor a descendant of the container this.$el
        if (this.el.contains(e.target) === false) {
            this.closePopupmenu();
        }
    }

    onClickButton(e) {
        // When the button has an active state
        if (this.isActive) {
            // Stop other logic to prevent weird behaviour
            e.preventDefault();

            // Open the popupmenu
            this.openPopupMenu(e);

            // When the button has an inactive state
        } else {

            // Only do this if popup is closed, this fixes the issue where a row/column deletion
            // removes the active element which make this.isActive false while it should be true.
            // A click on the button or outside the popup will close the popup, so this will
            // happen when a user clicks outside of the table to create a new table.
            if (this.popup === undefined) {

                // Call the original onClickButton
                super.onClickButton.call(this, e)

                // When menu is open
            } else {

                // Close the popup menu since we lost focus
                this.closePopupmenu();
            }
        }
    }

    closePopupmenu() {

        // Reenable the tooltip
        this.disableTooltip = false;

        this.popup.find('.js-table-option-button').off('click', this.onClickTableOption);

        // Remove popup from DOM
        this.popup.remove();

        // Clear popup variable
        delete this.popup

        // Remove global click listener
        document.removeEventListener('click', this.mouseUpDocument)
        this.wysiwyg.editor.getDoc().removeEventListener('click', this.mouseUpDocument)

    }

    openPopupMenu(e) {

        // do not close the hidden buttons holder onClick
        e.stopPropagation();

        this.table = this.wysiwyg.editor.selection.getNode().closest('table');
        this.border = this.table.classList.contains('has-border');

        // Check if there isn't already a popup open
        if (this.popup === undefined) {

            // Create a new popup using the SymbolPopupTemplate
            this.popup = $(TableOptionsPopup({
                // Pass styles with it
                Styles: this.Styles,
                toggleBorder: this.border ? this.removeBorderTitle : this.addBorderTitle
            }));

            // Add the popup to the DOM
            this.$('.js-icon-holder').after(this.popup);

            // Disable tooltip functionality
            this.disableTooltip = true;

            // Call the onDeHoverButton function to remove tooltip if active
            this.onDeHoverButton();

            // Add global click listener
            document.addEventListener('click', this.mouseUpDocument)
            this.wysiwyg.editor.getDoc().addEventListener('click', this.mouseUpDocument)

            // Search in this.popup for symbol buttons and added click listener to is
            this.popup.find('.js-table-option-button').on('click', this.onClickTableOption);

            // Right align instead of left align popup when it is too close to right edge of the editor toolbar.
            this.popup.css({
                right: this.$el.width() * this.$el.index() > this.popup.width() ? '-1px' : 'unset'
            })

            // Else when popup is open and clicked target is not popup
        } else if (!this.popup.is(e.target) &&
            this.popup.has(e.target).length === 0
        ) {
            // Close popupmenu
            this.closePopupmenu();
        }
    }

    onClickTableOption(e) {
        // Prevent table modal from opening
        this.stopAllEvents(e);

        // Distill the symbol from the clicked element
        var tableOptionCommand = e.currentTarget.dataset.command
        if (tableOptionCommand === 'toggleBorder') {
            this.toggleBorder();
        } else {

            // Check if the popup should be closed
            var closePopupmenu = e.currentTarget.dataset.once

            // Store the default command into a var
            var defaultCommand = this.command;

            // Update the command with the command of the tableOption
            this.command = tableOptionCommand;

            // Execute the MCE command
            this.wysiwyg.onMceCommand(this);

            // Restore the default command
            this.command = defaultCommand;
        }

        // If the popupmenu should be closed
        if (closePopupmenu) {

            // Close the popup menu
            this.closePopupmenu();
        }
    }

    addCommands(editorObject) {
        var editor = editorObject.editor;
        var customEl = editorObject.customEl;
        var customSH = editorObject.customSH;

        // Add the command for inserting images
        editor.addCommand('insertTable', function() {

            // Create a customElement of the type modalComponentElement
            customEl.modalComponentElement(

                // Set the modal title
                window.i18n.gettext('Create a table'),

                // Pass the to be inserted template
                TableTemplate,

                // Define the to-be-opened modal(view)
                TableMakerModal,

                // Pass the editor object
                editor
            );
        });

        // Create the state handler for this block element
        customSH.TableHandler(
            // Listen to command: insertTable
            'insertTable',

            // Pass the editor with it
            editor
        )
    }

    toggleBorder() {

        if (this.border) {
            this.table.classList.remove('has-border');
            this.border = false;
            $('.js-toggleBorder').empty().append(this.addBorderTitle);
        } else {
            this.table.classList.add('has-border');
            this.border = true;
            $('.js-toggleBorder').empty().append(this.removeBorderTitle);
        }
    }

}
